import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from 'react-hook-form';

interface FormControlLabelControllerProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<ControllerProps<TFieldValues, TName>, 'render'> {
  inputControl: FormControlLabelProps['control'];
  label?: FormControlLabelProps['label'];
  slotProps?: {
    formControlLabel?: Partial<FormControlLabelProps>;
  };
}

export const FormControlLabelController = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: FormControlLabelControllerProps<TFieldValues, TName>,
) => {
  const { label, slotProps, ...controllerProps } = props;
  return (
    <Controller
      {...controllerProps}
      render={({ field }) => (
        <FormControlLabel
          {...field}
          checked={field.value ?? false}
          label={label}
          control={props.inputControl}
          {...slotProps?.formControlLabel}
        />
      )}
    />
  );
};
